import React, { useContext, useEffect, useState } from 'react';
import SocketContext from 'utils/hooks/useSocket';

import { useTournament } from 'context/TournamentContext';

import TradeHero from 'components/game/TradeHero';
import TournamentBelt from 'components/game/TournamentBelt';
import GraphFilter from 'components/game/GraphFilter';
import TradingView from 'components/game/TradingView';

import { Box, Wrap, GraphWrapper, MobileBelt } from './styled';

const GraphBox = (props: { tournamentDetails: any }) => {
  const { tournamentPairList } = useTournament();
  const { tournamentDetails } = props;
  const [activeTime, setActiveTime] = useState('1s');
  const [chartType, setChartType] = useState('Candles');

  // TEAM_003: Support both legacy { data: { attributes: { trade_type } } }
  // and new flattened { data: { trade_type } } shapes.
  const rawData: any = tournamentDetails?.data;
  const attributes = rawData?.attributes ?? rawData?.data ?? rawData;
  const tournamentType = attributes?.trade_type;
  const { setAllCoins } = useContext(SocketContext) as any;

  useEffect(() => {
    setAllCoins(tournamentPairList);
  });

  return (
    <>
      <TradeHero />
      <MobileBelt>
        <TournamentBelt />
      </MobileBelt>
      <Box>
        <Wrap>
          <GraphFilter
            activeTime={activeTime}
            setActiveTime={setActiveTime}
            chartType={chartType}
            setChartType={setChartType}
          />
          <GraphWrapper className={tournamentType}>
            <TradingView activeTime={activeTime} chartType={chartType} />
          </GraphWrapper>
        </Wrap>
      </Box>
    </>
  );
};

export default GraphBox;
